import React from "react";
import { makeStyles, Box, Button, Typography, List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { Grid } from "ui/grid/Grid";
import { FunnelModal } from "ui/funnelModal/FunnelModal";
import CheckCircle from "components/funnel/assets/checkCircle.svg";
import ErrorCircle from "components/funnel/assets/errorCircle.svg";
import { INCLUDED_IN_INSTALLATION, NON_INCLUDED_IN_INSTALLATION, FAQ_URL } from "components/funnel/constants";

export default function InstallationTermsModal() {
  const classes = useStyle();
  const [open, setOpen] = React.useState(true);
  return (
    <FunnelModal
      size="sm"
      cancel={
        <Grid container item justify="space-evenly" className={classes.buttons}>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={(event) => {
                event.preventDefault();
                setOpen(false);
              }}
            >
              {`J'ai compris`}
            </Button>
          </Grid>
        </Grid>
      }
      open={open}
      title={
        <Box mt={2} mb={2}>
          <Typography className={classes.title} variant="h2">
            {`Mise en service de votre appareil`}
          </Typography>
        </Box>
      }
    >
      <Box pr={3} pl={3} pb={3} pt={1} ml={1} mr={1} mb={2}>
        <Grid container>
          <Grid item xs={12} style={{ textAlign: "start" }}>
            <Typography className={classes.subTitle} variant="caption">
              {`Compris dans la mise en service`}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <List dense className={classes.listContainer}>
              {INCLUDED_IN_INSTALLATION.map((term) => {
                return (
                  <ListItem disableGutters className={classes.listItemContainer} key={term.id}>
                    <ListItemIcon>
                      <CheckCircle />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography variant="caption" className={classes.listItem}>
                          {term.text}
                        </Typography>
                      }
                    />
                  </ListItem>
                );
              })}
            </List>
          </Grid>
        </Grid>
        <div className={classes.divider} />
        <Grid container>
          <Grid item xs={12} style={{ textAlign: "start" }}>
            <Typography className={classes.subTitle} variant="caption">
              {`Non-compris dans la mise en service`}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <List dense className={classes.listContainer}>
              {NON_INCLUDED_IN_INSTALLATION.map((term) => {
                return (
                  <ListItem disableGutters className={classes.listItemContainer} key={term.id}>
                    <ListItemIcon>
                      <ErrorCircle />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography variant="caption" className={classes.listItem}>
                          {term.text}
                        </Typography>
                      }
                    />
                  </ListItem>
                );
              })}
            </List>
          </Grid>
        </Grid>
        <div className={classes.divider} />
        <Box>
          <Typography variant={"caption"} className={classes.listItem}>
            {`Pour plus d'informations, consultez notre `}
            <a href={FAQ_URL} target="_blank" rel="noopener noreferrer" key={FAQ_URL}>
              FAQ
            </a>
          </Typography>
        </Box>
      </Box>
    </FunnelModal>
  );
}

const useStyle = makeStyles((theme) => ({
  error: {
    fontSize: 16,
  },
  buttons: {
    margin: theme.spacing(0, 0, 2),
  },
  title: {
    color: theme.palette.secondary.main,
    textAlign: "center",
  },
  subTitle: {
    color: theme.palette.secondary.main,
    fontWeight: "bold",
  },
  listContainer: {
    "& .MuiListItem-root": {
      padding: theme.spacing(0),
    },
  },
  listItemContainer: {
    "& .MuiListItemIcon-root": {
      minWidth: 8,
      marginRight: theme.spacing(1),
    },
  },
  listItem: {
    color: theme.palette.secondary.main,
  },
  divider: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    backgroundColor: "#DBDFE8",
    height: 1,
    width: "100%",
  },
}));
